import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

// modules
import user from './modules/user';
import addinfo from './modules/addinfo';

export default createStore({
  modules: {
    user,
    addinfo
  },
  plugins: [
    createPersistedState({
      key: 'user',
      paths: ['user'],
      storage: window.sessionStorage
    }),
    createPersistedState({
      key: 'addinfo',
      paths: ['addinfo'],
      storage: window.sessionStorage
    })
  ]
});
